// Test IDs for the Jak hrát (how to play / getting started) page.

export const JAK_HRAT_PAGE = {
  section: "jak-hrat-page",
  heroSection: "jak-hrat-hero-section",
  forewordSection: "jak-hrat-foreword-section",
  stepsSection: "jak-hrat-steps-section",
  stepCard: "jak-hrat-step-card",
  ctaSection: "jak-hrat-cta-section",
  downloadClientButton: "jak-hrat-download-client-button",
  downloadLauncherButton: "jak-hrat-download-launcher-button",
  registerButton: "jak-hrat-register-button",
  discordButton: "jak-hrat-discord-button",
};
